import { IntakeLabelCollection } from '../../entities/intake-label.interface';
export const InternationalAddressLabels: IntakeLabelCollection = {
  line1: {
    label: 'Street address',
  },

  line2: {
    label: 'Suite or unit #',
  },
  city: {
    label: 'City or town',
  },
  province: {
    label: 'Province or state',
  },
  postalCode: {
    label: 'Postal code or ZIP',
  },
  country: {
    label: 'Country',
  },
};
